import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Header, Hero, Work, Study, Skills, Activity, Footer } from "./components";
import Contact from "./components/Contact";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import PointerField from "./components/PointerField";
import { LanguageProvider } from "./i18n";

function Frame() {
  const { pathname } = useLocation();

  return (
    <div className="relative min-h-dvh">
      <div className={`bg-grid pointer-events-none fixed inset-0${pathname === "/projects" ? " is-off" : ""}`}>
        <PointerField />
      </div>
      <div className="relative">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </div>
  );
}

function Home() {
  const { hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (hash === "#contact") {
      navigate("/contact", { replace: true });
      return undefined;
    }
    if (!hash) return undefined;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const frame = requestAnimationFrame(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView({
        behavior: reduce ? "auto" : "smooth",
        block: "start",
      });
    });
    return () => cancelAnimationFrame(frame);
  }, [hash, navigate]);

  return (
    <div className="relative flex min-h-dvh flex-col">
      <Header />
      <main className="mx-auto w-full max-w-[760px] flex-1 px-5 pb-20 pt-10 sm:px-8">
        <Hero />
        <Work />
        <Study />
        <Skills />
        <Activity />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Frame />
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
